import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const UserService = {

  getOmeUser: async () => {
    try {
      const ome_user = localStorage.getItem("ome_user");

      if (ome_user) {
        const parsedUser = JSON.parse(ome_user);
        // console.log("UID:", parsedUser.uid);
        // console.log("Stringified:", JSON.stringify(parsedUser));
        return parsedUser; 
      }

      return null;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },


  getAllUsers: async () => {
    try {
      const response = await axios.get(ENDPOINT.Users);
      return response.data;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },

  getUserByRole: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Users}/role/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Project:", error.message);
      throw error;
    }
  },

  getLastUsers: async () => {
    try {
      const response = await axios.get(ENDPOINT.lastUsers);
      return response.data;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },

  createUsers: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Users, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },

  updateUsers: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Users}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },

  deleteUsers: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Users}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting Users:", error.message);
      throw error;
    }
  },

  createCustomer: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.customer, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },

  updateCustomer: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.customer}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },

  authValidation: async (data) => {
    try {
      const response = await axios.post(`${ENDPOINT.auth_vaildation}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },

  login: async (data) => {
    try {
      const response = await axios.post(`${ENDPOINT.login}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },

  createpass: async (data) => {
    try {
      const response = await axios.post(`${ENDPOINT.createpass}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },

  resetPassword: async (uid) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Users}/reset-password/${uid}`);
      return response.data;
    } catch (error) {
      console.error("Error resetting password:", error.message);
      throw error;
    }
  },

  logpass: async (data) => {
    try {
      const response = await axios.post(`${ENDPOINT.lopass}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Users:", error.message);
      throw error;
    }
  },


}